import styled from 'styled-components'

import { mainColors } from '@avantstay/backoffice-core'

import { SectionContainer } from './components/GlossarySection/GlossarySection.styles'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;

  ${SectionContainer} {
    padding: 20px;
  }
`

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: ${mainColors.neutralDark};
  text-align: center;
  font-size: 14px;
  line-height: 1.5;
`
